import React from "react"
import classes from "./Container.module.scss"

export default ({ className, children }) => {
  const classNames = [className, classes.Container]

  return <div className={classNames.join(" ")}>{children}</div>
}
